<script lang="ts" setup>
import { useBreadcrumbsStore } from '@/stores/breadcrumbs.store'

const breadcrumbsStore = useBreadcrumbsStore()
</script>

<template>
  <nav
    v-if="breadcrumbsStore.currentBreadcrumbs.length > 1"
    class="bread-crumbs"
    aria-label="Навигационная цепочка"
  >
    <VBreadcrumbs
      :items="breadcrumbsStore.currentBreadcrumbs"
      density="compact"
    >
      <template #divider>
        <VIcon
          icon="mdi-chevron-right"
          size="18"
        />
      </template>
    </VBreadcrumbs>
  </nav>
</template>

<style lang="scss">
.bread-crumbs {
  .v-breadcrumbs {
    min-height: 44px;
    padding: 8px 14px;
  }

  .v-breadcrumbs-item {
    color: var(--ui-text-muted);
    font-size: 0.8125rem;
  }

  .v-breadcrumbs-item--link {
    text-decoration: none;

    &:hover,
    &:focus-visible {
      color: var(--ui-focus-color);
    }
  }

  .v-breadcrumbs-divider {
    color: var(--ui-text-muted);
    opacity: 0.65;
  }
}
</style>
